// import { getTasksByEncounterIdQuery } from "~/features/dashboard/api/tasks/query";
import { ActionTask } from "../../../encounters/components/urgent-action-task";
import { Patient, PatientSessions, PatientDiagnosisResponse } from "../../api/types"
import { Button } from "@workspace/web-ui/components/button";
import { useSendActionNeededMutation } from "../../api/mutations";
import { toast } from "sonner";
// import { useQuery } from "@tanstack/react-query";

type SessionType = PatientSessions['sessions'][0];
type DiagnosisItem = NonNullable<SessionType['diagnosis']>[0];
type PatientDiagnosisItem = PatientDiagnosisResponse['diagnosis'][0];
type UnifiedDiagnosisItem = DiagnosisItem | PatientDiagnosisItem;

type DiagnosisProps = {
    diagnosis: PatientSessions | PatientDiagnosisResponse;
    userId: string;
    selectedSession?: SessionType;
    userDoseSpotId?: string;
    patient?: Patient
}
export const DiagnosisDetails = ({ diagnosis, 
    // userId, 
    selectedSession, 
    userDoseSpotId, 
    patient }: DiagnosisProps) => {
    // const { data: assignedTasks, isLoading } = useQuery(getTasksByEncounterIdQuery(selectedSession?.consultation_id ?? ""));
    const { mutate: sendActionNeeded, isPending: sendActionpending } = useSendActionNeededMutation();
    console.log("diagnosis", selectedSession)

    // Check if diagnosis is PatientDiagnosisResponse (has session and diagnosis properties)
    const isPatientDiagnosisResponse = 'session' in diagnosis && 'diagnosis' in diagnosis;

    let sessionsToShow: SessionType[] = [];
    let diagnosisToShow: PatientDiagnosisItem[] = [];

    if (isPatientDiagnosisResponse) {
        // Handle PatientDiagnosisResponse structure
        const diagnosisResponse = diagnosis as PatientDiagnosisResponse;
        if (diagnosisResponse.session && diagnosisResponse.diagnosis.length > 0) {
            // Convert the single session to match SessionType structure (without diagnosis)
            sessionsToShow = [{
                user_id: diagnosisResponse.session.user_id,
                session_id: diagnosisResponse.session.session_id,
                session_number: 0,
                session_type: diagnosisResponse.session.session_type,
                start_datetime: diagnosisResponse.session.start_datetime,
                thread_id: diagnosisResponse.session.thread_id,
                agent_id: diagnosisResponse.session.agent_id,
                status: diagnosisResponse.session.status,
                onboard_session: '',
                alfie_session: diagnosisResponse.session.alfie_session,
                payment_status: diagnosisResponse.session.payment_status,
                treatment_completed: diagnosisResponse.session.treatment_completed,
                is_red_flagged: false,
                created_at: diagnosisResponse.session.created_at,
                consultation_id: '',
                reported_symptom: diagnosisResponse.session.reported_symptom,
                state: '',
                tasks: [],
                diagnosis: [], // Empty array, we'll use diagnosisToShow instead
                encounter: undefined,
                intake_questions: diagnosisResponse.session.intake_questions,
                red_flag_questions: diagnosisResponse.session.red_flag_questions
            }];
            diagnosisToShow = diagnosisResponse.diagnosis;
        }
    } else {
        // Handle PatientSessions structure
        const patientSessions = diagnosis as PatientSessions;
        sessionsToShow = selectedSession
            ? [selectedSession]
            : patientSessions.sessions?.filter(session => session?.diagnosis?.length) || [];
    }

    return (
        <div className="px-2">
            {sessionsToShow.map((session, index) => {
                const diagnosisItems = ((isPatientDiagnosisResponse ? diagnosisToShow : session.diagnosis) ?? []) as UnifiedDiagnosisItem[];
                const primaryDiagnosis = diagnosisItems[0];
                const diseaseName = primaryDiagnosis?.disease_name?.toLowerCase() ?? "";
                const isSTI = diseaseName.includes("chlamydia") ||
                    diseaseName.includes("gonorrhea") ||
                    diseaseName.includes("herpes") ||
                    diseaseName.includes("trichomonas") ||
                    diseaseName.includes("bacterial vaginosis") ||
                    diseaseName.includes("yeast infection") ||
                    diseaseName.includes("vulvovaginal candidiasis") ||
                    diseaseName.includes("sti") ||
                    diseaseName.includes("std") ||
                    diseaseName.includes("urethritis") ||
                    diseaseName.includes("sexually transmitted");

                const toEntries = (questions: unknown) => {
                    if (!questions || typeof questions !== "object" || questions === null) {
                        return [];
                    }

                    return Object.entries(questions as Record<string, string | null>);
                };

                console.log("intake", session?.red_flag_questions)
                const intakeQuestionEntries = toEntries(session?.intake_questions);
                const redFlagQuestionEntries = toEntries(session?.red_flag_questions);

                const formatAnswer = (answer: unknown) => {
                    if (typeof answer === "string") {
                        return answer.trim().length > 0 ? answer : "No response provided";
                    }

                    if (answer === null || answer === undefined) {
                        return "No response provided";
                    }

                    try {
                        return String(answer);
                    } catch {
                        return "No response provided";
                    }
                };

                const additionalQuestion = typeof primaryDiagnosis?.treatment_page?.additional_question === "string"
                    ? primaryDiagnosis.treatment_page.additional_question
                    : null;

                const imageUrls = Array.isArray(primaryDiagnosis?.image_urls)
                    ? primaryDiagnosis.image_urls.filter((url): url is string => typeof url === "string" && url.length > 0)
                    : [];

                const shouldShowStiExtras = isSTI && (additionalQuestion || imageUrls.length > 0);
                const shouldShowCard = intakeQuestionEntries.length > 0 || redFlagQuestionEntries.length > 0 || shouldShowStiExtras;

                return (
                    <div key={`${session.session_id}-${index}`}>
                        {shouldShowCard && (
                            <div className="my-4 w-full bg-[#FEF3C7] p-4 rounded-[8px] border border-[#FDE68A]">
                                <div className="flex flex-col gap-3">
                                    <div className="flex flex-col space-y-1">
                                        <p className="text-[#1A202C] font-semibold">General Questions</p>
                                        {intakeQuestionEntries.length > 0 ? (
                                            <ul className="text-[#464B55] text-[14px] list-disc ml-4 space-y-1">
                                                {intakeQuestionEntries.map(([question, answer]: [string, string | null], questionIndex: number) => (
                                                    <li key={`${question}-${questionIndex}`}>
                                                        <span className="font-medium text-[#1A202C]">{question}</span>
                                                        {": "}
                                                        <span>{formatAnswer(answer)}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p className="text-[#464B55] text-[14px]">No general questions available</p>
                                        )}
                                    </div>

                                    <div className="flex flex-col space-y-1">
                                        <p className="text-[#1A202C] font-semibold">Red flag Questions</p>
                                        {redFlagQuestionEntries.length > 0 ? (
                                            <ul className="text-[#464B55] text-[14px] list-disc ml-4 space-y-1">
                                                {redFlagQuestionEntries.map(([question, answer]: [string, string | null], questionIndex: number) => (
                                                    <li key={`${question}-${questionIndex}`}>
                                                        <span className="font-medium text-[#1A202C]">{question}</span>
                                                        {": "}
                                                        <span>{formatAnswer(answer)}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p className="text-[#464B55] text-[14px]">No red flag questions available</p>
                                        )}
                                    </div>

                                    {shouldShowStiExtras && (
                                        <>
                                            <hr className="border-[#FDE68A]" />
                                            <div className="flex flex-col space-y-1">
                                                <p className="text-[#1A202C] font-semibold">Additional information</p>
                                                <p className="text-[#464B55] text-[14px]">
                                                    {additionalQuestion || "No additional information available"}
                                                </p>
                                            </div>

                                            <hr className="border-[#FDE68A]" />
                                            <div className="flex flex-col space-y-1">
                                                <p className="text-[#1A202C] font-semibold">Image attachment</p>
                                                {imageUrls.length > 0 ? (
                                                    <div className="flex flex-wrap gap-2 mt-2">
                                                        {imageUrls.map((url, imageIndex) => (
                                                            <a
                                                                key={imageIndex}
                                                                href={url}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className="text-[#4272DD] text-[14px] underline hover:text-[#2E5FCC]"
                                                            >
                                                                Image {imageIndex + 1}
                                                            </a>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <p className="text-[#464B55] text-[14px]">No images attached</p>
                                                )}
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        )}
                        <div className="mb-6">
                            <div className="">
                                {diagnosisItems.map((diagnosisItem: UnifiedDiagnosisItem, diagnosisIndex: number) => (
                                    <div key={diagnosisIndex} className="space-y-3">
                                        {/* <h2 className="text-md font-medium text-[#1A202C]">
                                {diagnosisItem.disease_name}
                                </h2> */}
                                        <div className="rounded-[8px] bg-[#EBF0FB] p-4 divide-y divide-[#0404041A] space-y-2">
                                            <div className="flex flex-col">
                                                <h3 className="text-lg font-semibold mb-2">Reported Symptoms</h3>
                                                <div className="flex items-center gap-3 text-sm text-[#464B55] space-y-1">
                                                    {/* {diagnosisItem.symptoms.map((symptom, symptomIndex) => (
                                            <p key={symptomIndex}>{symptom}</p>
                                        ))} */}
                                                    {session.reported_symptom ? session.reported_symptom : "No symptoms reported"}
                                                </div>
                                            </div>
                                            <div className="pt-2">
                                                <h1 className="text-lg font-semibold mb-2">Alfie's Diagnosis</h1>
                                                {/* <h3 className="text-sm font-medium text-[#1A202C] mb-1">Overview</h3> */}
                                                <p className="text-sm text-[#464B55]">{diagnosisItem.overview}</p>
                                            </div>
                                            {diagnosisItem.treatment_page && (
                                                <div className="pt-2">
                                                    <h1 className="text-lg font-semibold mb-2">Alfie's Recommended Treatment</h1>
                                                    <div className="text-sm text-[#464B55] space-y-4">
                                                        {diagnosisItem.treatment_page.medications.map((medication, medIndex) => (
                                                            <div key={medIndex}>
                                                                {/* Medication name (if available) */}
                                                                {medication.medication && (
                                                                    <div>
                                                                        <p className="text-[#464B55] font-semibold text-[14px] mb-1">Medication</p>
                                                                        <h4 className="text-gray-700 mb-2">{medication.medication}</h4>
                                                                    </div>
                                                                )}

                                                                <div>
                                                                    <p className="text-[#464B55] font-semibold text-[14px] mb-1 mt-1">Instructions</p>
                                                                    {/* Instructions for this medication */}
                                                                    <ul className="list-disc list-inside space-y-1">
                                                                        {(medication.instructions ?? []).map((instruction: string, index: number) => (
                                                                            <li key={index}>{instruction}</li>
                                                                        ))}
                                                                    </ul>
                                                                </div>

                                                                {/* Horizontal line separator (except for the last medication) */}
                                                                {diagnosisItem.treatment_page && medIndex < diagnosisItem.treatment_page.medications.length - 1 && (
                                                                    <hr className="border-gray-200 border mt-4" />
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        {/* {diagnosisItem.image_urls && diagnosisItem.image_urls.length > 0 && (
                                <div>
                                    <h3 className="text-sm font-medium text-[#1A202C] mb-2">Images</h3>
                                    <div className="flex flex-wrap gap-2">
                                        {diagnosisItem.image_urls.map((imageUrl, imageIndex) => (
                                            <img 
                                                key={imageIndex} 
                                                src={imageUrl} 
                                                alt={`Diagnosis image ${imageIndex + 1}`}
                                                className="w-24 h-24 rounded-lg object-cover"
                                            />
                                        ))}
                                    </div>
                                </div>
                            )} */}
                                    </div>
                                ))}
                            </div>
                        </div>
                        {patient?.urgent_care_onboarded && patient?.identity_verified ? (
                            <ActionTask selectedSession={session} userDoseSpotId={userDoseSpotId} patient={patient} assignedTasks={session.encounter?.recommended_tasks} />
                        ) : (
                            <div className="flex items-center bg-[#F0F5FF] rounded-lg px-4 py-2 justify-between w-full">
                                <p className="text-sm text-[#1A202C]">
                                    Patient must be verified
                                </p>
                                <Button
                                    className="button-primary !bg-[#4272DD] h-[44px] !text-white flex gap-2 items-center !shadow-none w-fit !border-none"
                                    onClick={async () => {
                                        try {
                                            if (patient?.userId) {
                                                await sendActionNeeded({ patient_id: patient.userId });
                                                toast.success("Reminder sent to patient to complete verification.");
                                            }
                                        } catch (error) {
                                            toast.error("Failed to send reminder.");
                                        }
                                    }}
                                    disabled={sendActionpending || !patient?.userId}
                                >
                                    {sendActionpending && (
                                        <svg className="animate-spin h-4 w-4 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                                        </svg>
                                    )}
                                    Send a Reminder
                                </Button>
                            </div>
                        )}

                    </div>
                );
            })}
        </div>
    )
}
